import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import Message from './Message';
import ApiErrors from './ApiErrors';
import { MessageTypes } from '../../constants';

class Messages extends React.Component {
  state = {
    open: true,
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { message } = this.props;

    return message.type === MessageTypes.API_ERRORS ? (
      <ApiErrors open={this.state.open} onClose={this.handleClose} message={message.content} />
    ) : (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={this.state.open}
      >
        <Message
          onClose={this.handleClose}
          variant={message.type}
          message={message.content}
          key={message.type + message.content}
        />
      </Snackbar>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.message !== prevProps.message) {
      this.setState({ open: true });
    }
  }
}

Messages.propTypes = {
  message: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    message: state.message,
  };
}

export default connect(mapStateToProps)(Messages);
